import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

// =============================================================================
// Grid Layout Field Icons
// =============================================================================

export function GridColumns(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "GridColumns",
    viewBox: "0 0 24 24",
    path: (
      <>
        <rect
          x="3"
          y="3"
          width="7"
          height="18"
          rx="1"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <rect
          x="14"
          y="3"
          width="7"
          height="18"
          rx="1"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function GridRows(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "GridRows",
    viewBox: "0 0 24 24",
    path: (
      <>
        <rect
          x="3"
          y="3"
          width="18"
          height="7"
          rx="1"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <rect
          x="3"
          y="14"
          width="18"
          height="7"
          rx="1"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function GridGap(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "GridGap",
    viewBox: "0 0 24 24",
    path: (
      <path
        d="M21 12H3M21 12l-4-4m4 4l-4 4M3 12l4-4m-4 4l4 4"
        stroke="currentColor"
        strokeWidth="2"
        className="icon-outline"
      />
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function GridAlign(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "GridAlign",
    viewBox: "0 0 24 24",
    path: (
      <>
        <rect
          x="4"
          y="5"
          width="16"
          height="4"
          rx="1"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <rect
          x="4"
          y="15"
          width="16"
          height="4"
          rx="1"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="12"
          y1="2"
          x2="12"
          y2="22"
          stroke="currentColor"
          strokeWidth="2"
          strokeDasharray="2 2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function GridJustify(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "GridJustify",
    viewBox: "0 0 24 24",
    path: (
      <>
        <rect
          x="5"
          y="4"
          width="4"
          height="16"
          rx="1"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <rect
          x="15"
          y="4"
          width="4"
          height="16"
          rx="1"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="2"
          y1="12"
          x2="22"
          y2="12"
          stroke="currentColor"
          strokeWidth="2"
          strokeDasharray="2 2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}
